"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCustomerBalanceState = void 0;
const domain_1 = require("@oolio-group/domain");
const order_helper_1 = require("@oolio-group/order-helper");
const eventHandlerMap = {
    [domain_1.OnAccountAction.ON_ACCOUNT_PAYMENT]: onAccountPayment,
    [domain_1.OnAccountAction.ON_ACCOUNT_PAYMENT_PROCESSED]: onAccountPaymentProcessed,
};
function onAccountPayment(event, prevValue) {
    var _a, _b;
    const paymentStatus = event.paymentStatus
        ? event.paymentStatus
        : domain_1.OrderPaymentStatus.COMPLETE;
    let { amount = 0, roundOffDifference = 0 } = prevValue;
    amount = (0, order_helper_1.limitDecimalCount)((0, order_helper_1.sumDecimals)([(_a = prevValue.amount) !== null && _a !== void 0 ? _a : 0, event.tendered, , -event.change]));
    roundOffDifference = (0, order_helper_1.limitDecimalCount)((0, order_helper_1.sumDecimals)([(_b = prevValue.roundOffDifference) !== null && _b !== void 0 ? _b : 0, event.roundOffDifference]));
    return {
        ...prevValue,
        amount,
        roundOffDifference,
        ...(paymentStatus === domain_1.OrderPaymentStatus.PENDING && {
            cardPayment: {
                amount: event.tendered,
                paymentStatus: domain_1.OrderPaymentStatus.PENDING,
                tip: event.tip,
                paymentRequestId: event.paymentRequestId,
            },
        }),
    };
}
function onAccountPaymentProcessed(event, prevValue) {
    var _a, _b, _c, _d, _e, _f, _g;
    let { amount, paymentSurcharge, tip } = prevValue;
    if (event.paymentStatus === domain_1.OrderPaymentStatus.COMPLETE) {
        paymentSurcharge = (0, order_helper_1.limitDecimalCount)((0, order_helper_1.sumDecimals)([
            (_a = event.paymentSurcharge) !== null && _a !== void 0 ? _a : 0,
            (_b = prevValue.paymentSurcharge) !== null && _b !== void 0 ? _b : 0,
        ]));
        tip = (0, order_helper_1.limitDecimalCount)((0, order_helper_1.sumDecimals)([(_c = event.paymentTip) !== null && _c !== void 0 ? _c : 0, (_d = prevValue.tip) !== null && _d !== void 0 ? _d : 0]));
    }
    else {
        amount = (0, order_helper_1.limitDecimalCount)((0, order_helper_1.sumDecimals)([
            (_f = (_e = prevValue.cardPayment) === null || _e === void 0 ? void 0 : _e.amount) !== null && _f !== void 0 ? _f : 0,
            -((_g = prevValue.amount) !== null && _g !== void 0 ? _g : 0),
        ]));
    }
    delete prevValue.cardPayment;
    return { ...prevValue, amount, paymentSurcharge, tip };
}
function computeCustomerBalanceState(events, prevValue = {}) {
    return events.reduce((initialValue, event) => {
        const computeNextOrderState = eventHandlerMap[event.action];
        if (typeof computeNextOrderState === 'function') {
            const balance = computeNextOrderState(event, initialValue);
            return balance;
        }
        else {
            throw new Error(`handler not defined for order action: ${event.action}`);
        }
    }, prevValue);
}
exports.computeCustomerBalanceState = computeCustomerBalanceState;
exports.default = eventHandlerMap;
//# sourceMappingURL=onAccountEvents.js.map